export default "__VITE_ASSET__d0c0f0a2__"